import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../config/config";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [loginMessage, setLoginMessage] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [successMessage, setSuccessMessage] = useState();
  const [company, setCompany] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    if (token) {
      setIsLoggedIn(true);
    }
  }, []);

  const handleRegister = async (formData) => {
    try {
      const response = await axios.post(`${BASE_URL}/signUp`, formData, {
        headers: { "Content-Type": "application/json" },
      });
      return { success: true, data: response.data };
    } catch (error) {
      const message =
        error.response?.data?.message ||
        "Registration failed. Please try again.";
      return { success: false, message };
    }
  };

  const handleLogin = async (credentials) => {
    try {
      const response = await axios.post(`${BASE_URL}/login`, credentials);

      const { token, message } = response.data;

      if (token) {
        sessionStorage.setItem("authToken", token);
        setIsLoggedIn(true);
        setSuccessMessage(message || "Login successful!");

        return { success: true, message };
      } else {
        return { success: false, message: message || "Invalid credentials" };
      }
    } catch (error) {
      const backendMessage = error.response?.data?.message;

      return {
        success: false,
        message: backendMessage || "Invalid email or password",
      };
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem("authToken");
    setIsLoggedIn(false);
    setSuccessMessage("");
    navigate("/login");
  };
  useEffect(() => {
    axios
      .get(`${BASE_URL}/companyDetails`)
      .then((res) => {
        if (res.data?.status && res.data.data.length > 0) {
          setCompany(res.data.data[0]);
        }
      })
      .catch((err) => {
        console.error("Error fetching company details:", err);
      });
  }, []);

  return (
    <AuthContext.Provider
      value={{
        handleRegister,
        handleLogin,
        handleLogout,
        loginMessage,
        setIsLoggedIn,
        company,
        isLoggedIn,
        successMessage,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
